import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VrcCalendarEventsService {
  private _url = '';
  constructor(private http: HttpClient) {   /* empty */ }

  public get url(): string {
    if (!this._url || this._url === '') {
      throw new Error('VR DATEPICKER: URL para obter dias não úteis não foi informada!');

    }
    return this._url;
  }
  public set url(v: string) {
    this._url = v;
  }

  getNonWorkingDays(year: number | string): Observable<{ date: string, name: string }[]> {
    const params = new HttpParams().set('ano', year.toString());
    const queryParams: {} = { params, observe: 'body' };
    return this.http.get<{ date: string, name: string }[]>(this.url, queryParams).pipe(take(1));
  }
}
